export enum Direction {
  Outward,
  Return,
}

export enum PassengerType {
  Adult = "STDA",
  Child = "STDC",
  Infant = "STDI",
  AdultConcession = "VCNA",
  ChildConcession = "VCNC",
  InfantConcession = "VCNI",
}
